import { z } from 'zod';
import { tierSchema } from '@forcebase-ai/core';

// src/command.ts
var tierCounts = z.object({ basic: z.number(), premium: z.number(), fighter: z.number() });
var kpiSummarySchema = z.object({
  members_by_tier: tierCounts,
  active_members: z.number(),
  mrr_cents: z.number(),
  visits: z.object({ active: z.number(), upcoming: z.number(), completed: z.number() }),
  pending_applications: z.number(),
  failed_sync: z.number(),
  open_drift: z.number()
});
var memberRowSchema = z.object({
  id: z.string().uuid(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  tier: tierSchema,
  status: z.string(),
  stripe_customer_id: z.string().nullable().optional(),
  healthie_patient_id: z.string().nullable().optional()
});
var memberDetailSchema = z.object({
  member: memberRowSchema.extend({
    phone: z.string().nullable().optional(),
    stripe_subscription_id: z.string().nullable().optional(),
    created_at: z.string()
  }),
  subscription: z.object({
    product: z.string(),
    status: z.string(),
    current_period_end: z.string().nullable().optional()
  }).nullable(),
  payments: z.array(
    z.object({
      amount_cents: z.number(),
      currency: z.string(),
      status: z.string(),
      created_at: z.string()
    })
  )
});
var doctorRowSchema = z.object({
  id: z.string().uuid(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  specialty: z.string().nullable().optional(),
  zoom_user_id: z.string().nullable().optional(),
  healthie_provider_id: z.string().nullable().optional(),
  application_status: z.string()
});
var doctorDetailSchema = z.object({
  doctor: doctorRowSchema,
  credentials: z.object({
    npi: z.string(),
    dea_number: z.string().nullable().optional(),
    license_state: z.string(),
    license_number: z.string(),
    license_expires_at: z.string().nullable().optional(),
    malpractice_carrier: z.string().nullable().optional(),
    malpractice_policy_no: z.string().nullable().optional(),
    malpractice_expires_at: z.string().nullable().optional(),
    agreement_version: z.string().nullable().optional(),
    agreement_accepted_at: z.string().nullable().optional(),
    baa_accepted_at: z.string().nullable().optional()
  }).nullable()
});
var applicationRowSchema = z.object({
  id: z.string().uuid(),
  kind: z.enum(["fighter", "doctor"]),
  applicant_email: z.string(),
  payload: z.record(z.unknown()).nullable().optional(),
  status: z.string(),
  reviewed_at: z.string().nullable().optional(),
  created_at: z.string()
});
var visitRowSchema = z.object({
  id: z.string().uuid(),
  patient_id: z.string().uuid(),
  doctor_id: z.string().uuid(),
  scheduled_at: z.string(),
  label: z.string(),
  status: z.string(),
  emr_sync_status: z.string().nullable().optional(),
  zoom_sync_status: z.string().nullable().optional(),
  cancelled_at: z.string().nullable().optional(),
  cancel_reason: z.string().nullable().optional(),
  updated_at: z.string().nullable().optional()
});
var visitHistoryRowSchema = z.object({
  id: z.string().uuid(),
  event: z.string(),
  actor_role: z.string().nullable().optional(),
  from_time: z.string().nullable().optional(),
  to_time: z.string().nullable().optional(),
  reason: z.string().nullable().optional(),
  created_at: z.string()
});
var paymentsViewSchema = z.object({
  subscriptions: z.array(
    z.object({
      patient_id: z.string().uuid(),
      product: z.string(),
      status: z.string(),
      current_period_end: z.string().nullable().optional()
    })
  ),
  payments: z.array(
    z.object({
      patient_id: z.string().uuid(),
      amount_cents: z.number(),
      currency: z.string(),
      status: z.string(),
      created_at: z.string()
    })
  )
});
var emrSyncRowSchema = z.object({
  id: z.string().uuid(),
  patient_id: z.string().uuid().nullable().optional(),
  doctor_id: z.string().uuid().nullable().optional(),
  emr_sync_status: z.string().nullable().optional(),
  zoom_sync_status: z.string().nullable().optional(),
  updated_at: z.string().nullable().optional()
});
var reconciliationRowSchema = z.object({
  id: z.string().uuid(),
  source: z.string(),
  healthie_appointment_id: z.string().nullable().optional(),
  kind: z.string(),
  detail: z.record(z.unknown()).nullable().optional(),
  created_at: z.string()
});
var auditRowSchema = z.object({
  id: z.union([z.string(), z.number()]),
  actor_id: z.string().nullable().optional(),
  actor_role: z.string().nullable().optional(),
  action: z.string(),
  entity: z.string(),
  entity_id: z.string().nullable().optional(),
  phi_class: z.string().nullable().optional(),
  at: z.string()
});
var commandSettingsSchema = z.object({
  reschedule_min_lead_minutes: z.number(),
  cancel_min_lead_minutes: z.number(),
  late_cancel_policy: z.string(),
  visit_reminder_offsets: z.array(z.string()),
  emr_adapter: z.string()
});
var staffRowSchema = z.object({
  id: z.string(),
  email: z.string(),
  role: z.string(),
  created_at: z.string()
});
var inviteStaffResultSchema = z.object({
  email: z.string(),
  role: z.enum(["doctor", "command"]),
  status: z.enum(["created", "exists"])
});

export { applicationRowSchema, auditRowSchema, commandSettingsSchema, doctorDetailSchema, doctorRowSchema, emrSyncRowSchema, inviteStaffResultSchema, kpiSummarySchema, memberDetailSchema, memberRowSchema, paymentsViewSchema, reconciliationRowSchema, staffRowSchema, visitHistoryRowSchema, visitRowSchema };
//# sourceMappingURL=chunk-VT6UKR43.js.map
//# sourceMappingURL=chunk-VT6UKR43.js.map